import { useEffect, useState } from 'react';
import { FeatureContext } from '../../../Context';
import { lang, useBfGlobals, useQuery } from '../../../Utils';
import Details from "./Details";
import { ChakraProvider, Tabs, TabList, Tab, TabPanels, TabPanel, useDisclosure } from '@chakra-ui/react';
import { getOrderDetails } from '../Services';
import Invoices from './Invoices';
import { Error } from '../../../components/error/Error';
import Kanban from './Kanban';
import SidePanelDetail from './SidePanelDetail';
import Actions from './Actions';
import SidePanelDelivery from './SidePanelDelivery';
import { StatusList } from '../components/StatusList';
import Loader from '../../../components/loader/Loader';
import { NoDataFound } from '../../../ErrorType';
import OrderConfirmation from './OrderConfirmation';

const Index = () => {
  const { isOpen: isOpenSidePanelDetail, onOpen: onOpenSidePanelDetail, onClose: onCloseSidePanelDetail } = useDisclosure();
  const { isOpen: isOpenSidePanelDelivery, onOpen: onOpenSidePanelDelivery, onClose: onCloseSidePanelDelivery } = useDisclosure();
  
  const globals = useBfGlobals();

  const qs = useQuery();

  const [state, setState] = useState({
    loading: false,
    error: '',
    details: [],
    detail: {},
    delivery: {},
    invoices: [],
    orderConfirmation : [],
    kanbanState: false,
    currentTab: 0,
    setCurrentTab: (value) => setState(prevState => ({ ...prevState, currentTab: value })),
    toggleKanbanState: _ => setState(prevState => ({ ...prevState, kanbanState: !prevState.kanbanState })),
    setDetails: (value) => setState(prevState => ({ ...prevState, details: value })),
    setDetail: (value) => {
      setState(prevState => ({ ...prevState, detail: value }));
      onOpenSidePanelDetail();
    },
    setDelivery: (value) => {
      setState(prevState => ({ ...prevState, delivery: value }));
      onOpenSidePanelDelivery();
    },
    setInvoices: (value) => setState(prevState => ({ ...prevState, invoices: value })),
    setOrderConfirmation: (value) => setState(prevState => ({ ...prevState, orderConfirmation: value })),
    setLoading: {
      on: () => setState(prevState => ({ ...prevState, loading: true })),
      off: () => setState(prevState => ({ ...prevState, loading: false })),
    },
    setError: (value) => setState(prevState => ({ ...prevState, error: value })),
  });

  useEffect(() => {
    state.setLoading.on();
    getOrderDetails(qs.get('orderId'))
      .then(data => {
        state.setDetails(data?.salesOrderDetail);
        state.setInvoices(data?.invoiceDetail);
        state.setOrderConfirmation(data?.orderConfirmation);
      })
      .catch(error => {
        if (error instanceof NoDataFound) {
          state.setDetails([]);
          state.setInvoices([]);
          state.setOrderConfirmation([]);
        } else {
          state.setError(error);
        }
      })
      .finally(_ => state.setLoading.off());
  }, []);

  const render = () => {
    if (!!state.error) {
      return <Error error={state.error} />
    } else {
      return <>
        <a className="bf-link" href={globals.get('links.orders')}>{'< ' + lang('Back')}</a>
        <div className="bf-detail-status-list">
          <StatusList lang={lang} status={globals.get('orders_status.details')} labels={globals.get('order_details_description')} />
        </div>
        <Tabs className="bf-orders-tabs">
          <div className="bf-actions-wrapper">
            <TabList className="bf-orders-tabslist">
              <Tab className="bf-orders-tab" onClick={() => state.setCurrentTab(0)}>{lang('Details')}</Tab>
              <Tab className="bf-orders-tab" onClick={() => state.setCurrentTab(1)}>{lang('Invoices')}</Tab>
              <Tab className="bf-orders-tab" onClick={() => state.setCurrentTab(2)}>{lang('Order Confirmation')}</Tab>
            </TabList>
            <Actions />
          </div>
          <TabPanels className="bf-orders-panels">
            <TabPanel className="bf-orders-panel">
              {(!state.kanbanState) ? <Details /> : <Kanban />}
            </TabPanel>
            <TabPanel className="bf-orders-panel">
              <Invoices />
            </TabPanel>
            <TabPanel className="bf-orders-panel">
              <OrderConfirmation />
            </TabPanel>
          </TabPanels>
        </Tabs>
        <SidePanelDetail
          isOpen={isOpenSidePanelDetail}
          onClose={onCloseSidePanelDetail} />
        <SidePanelDelivery
          isOpen={isOpenSidePanelDelivery}
          onClose={onCloseSidePanelDelivery} />
      </>
    }
  }

  return <ChakraProvider>
    <FeatureContext.Provider value={state}>
      {(state.loading) ? <Loader /> : render()}
    </FeatureContext.Provider>
  </ChakraProvider>
}

export { Index }
